"use client";

import React, { useEffect, useState } from "react";

const COUNTRIES = ["Nigeria", "Kenya", "Ghana"];
const TYPE_MS = 120;
const DELETE_MS = 60;
const PAUSE_MS = 1400;

const TypewriterCountries = () => {
  const [countryIndex, setCountryIndex] = useState(0);
  const [charCount, setCharCount] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const country = COUNTRIES[countryIndex];
    let delay = isDeleting ? DELETE_MS : TYPE_MS;

    if (!isDeleting && charCount === country.length) delay = PAUSE_MS;

    const timeout = setTimeout(() => {
      if (!isDeleting && charCount === country.length) {
        setIsDeleting(true);
      } else if (isDeleting && charCount === 0) {
        setIsDeleting(false);
        setCountryIndex((prev) => (prev + 1) % COUNTRIES.length);
      } else {
        setCharCount((prev) => prev + (isDeleting ? -1 : 1));
      }
    }, delay);

    return () => clearTimeout(timeout);
  }, [charCount, isDeleting, countryIndex]);

  return (
    <>
      <span className="ss:sr-only">{COUNTRIES.join(", ")}</span>
      <span
        aria-hidden
        className="ss:font-bold ss:text-[#F5821F] ss:inline-block ss:min-w-[3ch]"
      >
        {COUNTRIES[countryIndex].slice(0, charCount)}
        <span className="ss:animate-pulse">|</span>
      </span>
    </>
  );
};

export default TypewriterCountries;
